import { parseResponseError } from "../Utils/errorUtils";
import axiosInstance from "../Utils/axiosInstance";
/**
 * Generic fucntion for call delete api
 * @param {*} path is the full path
 * @param {*} id
 * @returns
 */
export const deleteCall = async (path) => {
  try {
    let response = await axiosInstance.delete(`${path}`);

    return response.data;
  } catch (error) {
    return parseResponseError(error);
  }
};
